export default __webpack_public_path__ + "static/media/multi-pitch.eb35d69e.png";